import {
    ApplicationSubmitToDecisionGate,
    StatusContainer,
} from '@servicetitan/financing-utils-shared';
import { LoanDetails } from './LoanDetails';
import { SecondLookFinancingOption } from '../second-look';
import DeclinedIllustration from '../../common/illustrations/unable-to-load.svg';
import {
    useProviderConfig,
    useSecondLookIntegration,
    useSecondLookProviderName,
} from '@servicetitan/financing-workflow-shared';
import { Alert, Text } from '@servicetitan/anvil2';

export const Declined = () => {
    const { defaultWorkflowStage, declinedHeadline, declinedMessage } = useProviderConfig();
    const isExternalApplication = defaultWorkflowStage === 'external-application';
    const secondLookIntegration = useSecondLookIntegration();
    const secondLookProviderName = useSecondLookProviderName();

    return (
        <ApplicationSubmitToDecisionGate>
            {secondLookIntegration.isServiceDegraded && (
                <Alert status="warning" title={`Unable to submit to ${secondLookProviderName}`}>
                    <Text>
                        We're currently unable to submit your application to{' '}
                        {secondLookProviderName} due to a temporary service issue on our end. Please
                        try submitting a {secondLookProviderName} application later.
                    </Text>
                </Alert>
            )}
            <StatusContainer
                headline={isExternalApplication ? '' : (declinedHeadline ?? '')}
                message={isExternalApplication ? undefined : declinedMessage}
                image={DeclinedIllustration}
            >
                {isExternalApplication ? null : <LoanDetails hideDetails />}
                <SecondLookFinancingOption />
            </StatusContainer>
        </ApplicationSubmitToDecisionGate>
    );
};
